import { isShowNews1 } from "@/utils/isShowNews1";
import { nanoid } from "nanoid";
import { applyGooglePublisherTagPageConfig } from "@/components/common/GooglePublisherTag/pageLevelConfig";

const lazyLoadPositions1 = ["position-34", "position-35", "position-36", "position-42"];
function initializeGoogleAd({ slot, rect, id, dataPosition }: any) {
  // 初始化或复用全局googletag对象（Google广告API入口）
  window.googletag = window.googletag || { cmd: [] };
  // 将广告初始化逻辑放入googletag命令队列
  googletag.cmd.push(() => {
    // 获取当前已定义的所有广告位
    const existingSlots = googletag.pubads().getSlots();
    // 检查是否已存在相同ID的广告位
    const isSlotDefined = existingSlots.some((s: any) => s.getSlotElementId() === id);
    // 如果广告位未定义则进行初始化
    if (!isSlotDefined) {
      // 定义新广告位并关联到发布商广告服务
      googletag.defineSlot(slot, rect, id)?.addService(googletag.pubads());
      // 启用单请求模式（多个广告位合并为一个请求）
      // googletag.pubads().enableSingleRequest();
      // 自动折叠空广告容器
      // googletag.pubads().collapseEmptyDivs();
      googletag.setConfig({ collapseDiv: "ON_NO_FILL" });
      const isLazyLoadGroup1 = isShowNews1().isValidDismoreChannel && lazyLoadPositions1.includes(dataPosition);
      const shouldEnableLazyLoad = isLazyLoadGroup1;
      if (shouldEnableLazyLoad) {
        googletag.setConfig({
          lazyLoad: {
            fetchMarginPercent: 100,
            renderMarginPercent: 0,
            mobileScaling: 1.0,
          },
        });
      }
      // 启用广告服务
      applyGooglePublisherTagPageConfig();
      googletag.enableServices();
    }
  });
  // // 将广告展示逻辑放入googletag命令队列
  // googletag.cmd.push(() => {
  //   // 在指定DOM元素中展示广告
  //   googletag.display(id);
  // });
}

export default function Adx2(props: any) {
  const { id: propId, rect, slot, style, dataPosition } = props;
  const [uniqueId] = useState(`${propId}${nanoid(4)}`); // 确保每次渲染ID唯一
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  useEffect(() => {
    if (!isMounted) return;
    try {
      initializeGoogleAd({ slot, rect, id: uniqueId, dataPosition });
      // 确保 DOM 元素存在后再调用 display
      googletag.cmd.push(() => {
        if (document.getElementById(uniqueId)) {
          googletag.display(uniqueId);
          console.log("adx2广告display:", uniqueId);
        } else {
          console.warn(`Element with id ${uniqueId} not found in DOM`);
        }
      });

      return () => {
        googletag.cmd.push(() => {
          const slots = googletag.pubads().getSlots();
          const slotToDestroy = slots.find((s: any) => s.getSlotElementId() === uniqueId);
          if (slotToDestroy) {
            googletag?.destroySlots?.([slotToDestroy]);
          }
        });
      };
    } catch (error) {
      console.error("广告加载失败:", error);
    }
  }, [slot, rect, uniqueId, isMounted]);

  return (
    <div style={{ textAlign: "center" }} className="center">
      <div id={uniqueId} style={style}></div>
    </div>
  );
}
